import React, { useEffect } from 'react';
import { Alert } from 'reactstrap';
import { AlertTriangle } from 'react-feather';
import { toast } from 'react-toastify';

const LicenseUsageBanner = ({ warnAssets = [] }) => {
    useEffect(() => {
        if (!warnAssets || warnAssets.length === 0) return;
        const key = 'license-warn-toast-shown';
        if (sessionStorage.getItem(key)) return;
        toast.warn(`License usage >80% on ${warnAssets.length} asset(s). Review immediately.`);
        sessionStorage.setItem(key, '1');
    }, [warnAssets]);

    if (!warnAssets || warnAssets.length === 0) return null;

    return (
        <Alert color='danger' className='d-flex align-items-center'>
            <AlertTriangle size={18} className='me-2' />
            <span>
                License usage is above <strong>80%</strong> on{' '}
                <strong>{warnAssets.map(a => a.property_mall_code).join(', ')}</strong>. Plan a new PO to avoid consumption failures.
            </span>
        </Alert>
    );
};

export default LicenseUsageBanner;
